import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';

import Container from 'react-bootstrap/Container';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {
    Table
    , Pagination
    , Loader
    , Button
    , IconButton
    , ButtonToolbar
    , Input
    , Tooltip
    , Whisper
    , Modal
    , Text
    , Form
    , InputGroup
    , AutoComplete
} from 'rsuite';

import Swal from 'sweetalert2'
import $ from 'jquery';

export default class UsersPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authHeader: { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } },
            loading: false,
            content: null,
            data: [],
            sortColumn: '',
            sortType: '',
            limit: 5,
            page: 1,
            name: '',
            phone: '',
            username: '',
            password: '',
            confirm_password: '',
            changePassword: false,
        };
    }

    async componentDidMount() {
        await this.onRenderContent({ mode: 'read', query: '' })
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    adminHandleSortColumn = async (sortColumn, sortType) => {
        await this.promisedSetState({ loading: true });

        await new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 500);
        });

        await this.promisedSetState({ loading: false });
        await this.promisedSetState({ sortColumn, sortType });

        // Call your onRenderContent function if needed
        await this.onRenderContent({ read: true, query: '' });
    };

    adminGetData = async () => {
        if (this.state.sortColumn && this.state.sortType) {
            return this.state.data.sort((a, b) => {
                let x = a[this.state.sortColumn];
                let y = b[this.state.sortColumn];
                if (typeof x === 'string') {
                    x = x.charCodeAt();
                }
                if (typeof y === 'string') {
                    y = y.charCodeAt();
                }
                if (this.state.sortType === 'asc') {
                    return x - y;
                } else {
                    return y - x;
                }
            });
        }

        return this.state.data.filter((v, i) => {
            const start = this.state.limit * (this.state.page - 1);
            const end = start + this.state.limit;
            return i >= start && i < end;
        });
    };

    onRenderContent = async ({ mode, query }) => {
        if (mode === 'read') {
            try {
                const { Column, HeaderCell, Cell } = Table;

                await this.promisedSetState({ loading: true }); // Set loading state

                // Function to convert the Date to Thai format
                const convertToThaiDate = (dateString) => {
                    const monthsInThai = [
                        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                    ];

                    const date = new Date(dateString);
                    const day = date.getDate();
                    const month = monthsInThai[date.getMonth()];
                    const year = date.getFullYear() + 543; // Convert from Gregorian to Thai Buddhist year
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');

                    return `วันที่ ${day} ${month} ${year} เวลา ${hours}:${minutes}:${seconds}`;
                };

                const responseAPI = await axios.post(`${process.env.REACT_APP_API}/users/filter`, { query: query }, this.state.authHeader);
                const data = responseAPI.data.map((res, index) => ({
                    index: index + 1,
                    id: res.id,
                    name: res.name,
                    phone: res.phone,
                    username: res.username,
                    latest_access: convertToThaiDate(res.latest_access)
                }));

                await this.promisedSetState({ data: data });

                const paginatedData = await this.adminGetData();

                const autoComplete = responseAPI.data.map((res) => [
                    res.name,
                    res.username,
                ]);

                const flatAutoComplete = autoComplete.flat();

                const uniqueFlatAutoComplete = [...new Set(flatAutoComplete)];

                await this.promisedSetState({
                    content: <><Row className='mt-3'>
                        <Col>
                            <Breadcrumb size='lg' >
                                <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                <Breadcrumb.Item active>ผู้ดูแลระบบ (Admin)</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>
                        <Row className='mb-2'>
                            <Col>
                                <Text weight='bold'><i className="bi bi-person-fill-gear"></i>{' '}รายชื่อผู้ดูแลระบบ</Text>
                            </Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col>
                                <Button size='sm'
                                    startIcon={<i className="bi bi-plus-lg"></i>}
                                    color="green"
                                    appearance="primary"
                                    onClick={async () => {
                                        await this.promisedSetState({ name: '', phone: '', username: '', password: '', confirm_password: '' })
                                        await this.onModal({ mode: 'insert', read: false })
                                    }} >
                                    เพิ่ม
                                </Button>
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col>
                                <InputGroup>
                                    <InputGroup.Button tabIndex={-1}>
                                        <i className="bi bi-search"></i>
                                    </InputGroup.Button>
                                    <AutoComplete
                                        data={uniqueFlatAutoComplete}
                                        onChange={e => this.onRenderContent({ mode: 'read', query: e })} />
                                </InputGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Table
                                    autoHeight
                                    data={paginatedData}
                                    bordered
                                    cellBordered
                                    sortColumn={this.state.sortColumn}
                                    sortType={this.state.sortType}
                                    onSortColumn={async (sortColumn, sortType) => {
                                        await this.adminHandleSortColumn(sortColumn, sortType);
                                    }}
                                    className='shadow-sm'
                                >
                                    <Column width={60} align="center">
                                        <HeaderCell>ลำดับ</HeaderCell>
                                        <Cell dataKey="index" />
                                    </Column>

                                    <Column width={300} sortable>
                                        <HeaderCell>ชื่อ - นามสกุล</HeaderCell>
                                        <Cell dataKey="name" />
                                    </Column>

                                    <Column width={200} sortable>
                                        <HeaderCell>เบอร์โทรศัพท์</HeaderCell>
                                        <Cell dataKey="phone" />
                                    </Column>

                                    <Column width={220} sortable>
                                        <HeaderCell>username</HeaderCell>
                                        <Cell dataKey="username" />
                                    </Column>

                                    <Column width={415} sortable>
                                        <HeaderCell>วันที่และเวลา เข้าระบบล่าสุด</HeaderCell>
                                        <Cell dataKey="latest_access" />
                                    </Column>

                                    <Column width={100} align='center' fixed="right">
                                        <HeaderCell>...</HeaderCell>

                                        <Cell style={{ padding: '6px' }}>
                                            {rowData => (
                                                <ButtonToolbar>
                                                    <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                        <IconButton size='sm'
                                                            color="yellow"
                                                            appearance="primary"
                                                            icon={<i className="bi bi-pencil-square"></i>}
                                                            onClick={async () => {
                                                                await this.promisedSetState({ password: '', confirm_password: '', changePassword: false })
                                                                await this.onModal({ mode: 'update', id: rowData.id, read: false })
                                                            }}
                                                        />
                                                    </Whisper>
                                                    <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                        <IconButton size='sm'
                                                            color="red"
                                                            appearance="primary"
                                                            icon={<i className="bi bi-trash-fill"></i>}
                                                            onClick={() => this.onConfirm({ mode: 'delete', id: rowData.id })}
                                                        />
                                                    </Whisper>
                                                </ButtonToolbar>
                                            )}
                                        </Cell>
                                    </Column>
                                </Table>

                                <div style={{ padding: 20 }}>
                                    <Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '|', 'pager']}
                                        total={data.length}
                                        limit={this.state.limit}
                                        activePage={this.state.page}
                                        onChangePage={async (e) => {
                                            await this.promisedSetState({ page: e }); // Update current page
                                            await this.onRenderContent({ mode: 'read', query: '' }); // Fetch new data based on page
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row></>
                })
            } catch (error) {

                // Consider adding user feedback here
                console.error('API request failed:', error);

                // Redirect to Log In
                window.location.href = '/admin/login';
            } finally {
                await this.promisedSetState({ loading: false }); // Reset loading state
            }
        }
    }

    visiblePassword = async (obj) => {
        try {
            if (obj.type === 'password') {
                console.log('Toggling password visibility');
                await this.promisedSetState({ visiblePassword: !this.state.visiblePassword });
                this.onModal({ mode: obj.mode, id: obj.id, visible: true, read: true })
            } else if (obj.type === 'confirm_password') {
                console.log('Toggling confirm password visibility');
                await this.promisedSetState({ visibleCpassword: !this.state.visibleCpassword });
                this.onModal({ mode: obj.mode, id: obj.id, visible: true, read: true })
            }
            console.log('Updated state:', this.state);
        } catch (error) {
            console.error('Error in visiblePassword:', error);
        }
    }

    handleChangePassword = async ({ mode, id }) => {
        await this.promisedSetState({ changePassword: true });
        await this.onModal({ mode, id, read: false })
    };

    onModal = async ({ mode, id, read }) => {
        if (mode === 'insert') {
            if (read === false) {
                await this.promisedSetState({
                    name: '',
                    phone: '',
                    username: '',
                    password: '',
                    confirm_password: '',
                });
            }

            await this.promisedSetState({
                modal: <Modal size='sm' backdrop={'static'} open={true} onClose={() => this.setState({ modal: [] })}>
                    <Modal.Header>
                        <Modal.Title>เพิ่มรายชื่อผู้ดูแลระบบ (Admin)</Modal.Title>
                    </Modal.Header>
                    <hr />
                    <Modal.Body>
                        <Container>
                            <Form fluid>
                                <Row>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>ชื่อ - นามสกุล</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <Input
                                                className='0uD74'
                                                defaultValue={this.state.name}
                                                size='md'
                                                onChange={(e) => this.setState({ name: e })} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className='mt-3'>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>เบอร์โทรศัพท์</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <Input
                                                className='q4JQq'
                                                defaultValue={this.state.phone}
                                                size='md'
                                                onChange={(e) => this.setState({ phone: e })} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <br />

                                <Row className='mt-3'>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>Username</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <Input
                                                className='cgbZA'
                                                disabled={mode === 'update'}
                                                defaultValue={this.state.username}
                                                size='md'
                                                onChange={(e) => this.setState({ username: e })} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className='mt-3'>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>Password</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <InputGroup inside >
                                                <Input
                                                    className='zLynh'
                                                    defaultValue={this.state.password}
                                                    type={this.state.visiblePassword ? 'text' : 'password'}
                                                    onChange={(e) => this.setState({ password: e })} />
                                                <InputGroup.Button onClick={async () => {
                                                    await this.visiblePassword({ type: 'password', mode: mode, id: id })
                                                    await this.onModal({ mode: 'insert', read: true })
                                                }}>
                                                    {this.state.visiblePassword ? <i className="bi bi-eye-fill"></i> : <i className="bi bi-eye-slash-fill"></i>}
                                                </InputGroup.Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className='mt-3'>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>Confirm Password</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <InputGroup inside >
                                                <Input
                                                    className='hCxpm'
                                                    defaultValue={this.state.confirm_password}
                                                    type={this.state.visibleCpassword ? 'text' : 'password'}
                                                    onChange={(e) => this.setState({ confirm_password: e })} />
                                                <InputGroup.Button onClick={async () => {
                                                    await this.visiblePassword({ type: 'confirm_password', mode: mode, id: id })
                                                    await this.onModal({ mode: 'insert', read: true })
                                                }}>
                                                    {this.state.visibleCpassword ? <i class="bi bi-eye-fill"></i> : <i class="bi bi-eye-slash-fill"></i>}
                                                </InputGroup.Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className='mt-3'>
                                    <Col sm>
                                        <Text color="red">&#8226; รหัสผ่านประกอบด้วยตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น</Text>
                                        <Text color="red">&#8226; รหัสผ่านต้องมีความยาวระหว่าง 6 ถึง 18 ตัวอักษร</Text>
                                        <Text color="red">&#8226; รหัสผ่านต้องมีหมายเลขอย่างน้อยหนึ่งตัว</Text>
                                        <Text color="red">&#8226; รหัสผ่านต้องมีสัญลักษณ์อย่างน้อยหนึ่งตัว</Text>
                                    </Col>
                                </Row>
                            </Form>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size='sm'
                            startIcon={<i className="bi bi-floppy"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode: mode })}>
                            บันทึก
                        </Button>
                        <Button size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}>
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            });
        } else if (mode === 'update') {

            const { data } = await axios.get(`${process.env.REACT_APP_API}/users/${id}`, this.state.authHeader);
            const user = data[0];  // Assuming `data` is an array
            await this.promisedSetState({
                name: read === false ? user.name : this.state.name,
                phone: read === false ? user.phone : this.state.phone,
                username: read === false ? user.username : this.state.username
            });

            await this.promisedSetState({
                modal: <Modal size='sm'
                    backdrop={'static'}
                    open={true}
                    onClose={() => this.setState({ modal: [] })}>
                    <Modal.Header>
                        <Modal.Title>แก้ไขรายชื่อชื่อผู้ดูแลระบบ (Admin)</Modal.Title>
                    </Modal.Header>
                    <hr />
                    <Modal.Body>
                        <Container>
                            <Form fluid>
                                <Row>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>ชื่อ - นามสกุล</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <Input
                                                className='0uD74'
                                                defaultValue={user.name}
                                                size='md'
                                                onChange={(e) => this.setState({ name: e })} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className='mt-3'>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>เบอร์โทรศัพท์</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <Input
                                                className='q4JQq'
                                                defaultValue={user.phone}
                                                size='md'
                                                onChange={(e) => this.setState({ phone: e })} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <br />

                                <Row className='mt-3'>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>Username</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <Input
                                                className='cgbZA'
                                                disabled={mode === 'update'}
                                                defaultValue={user.username}
                                                size='md'
                                                onChange={(e) => this.setState({ username: e })} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {!this.state.changePassword && (<Row className='mt-3'>
                                    <Col sm>
                                        <Button startIcon={<i class="bi bi-key-fill"></i>}
                                            color="red"
                                            appearance="primary"
                                            onClick={e => this.handleChangePassword({ event: e, mode: mode, id: id })}
                                        >
                                            เปลี่ยนรหัสผ่าน
                                        </Button>
                                    </Col>
                                </Row>
                                )}

                                {this.state.changePassword && <><Row className='mt-3'>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>Password</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <InputGroup inside >
                                                <Input
                                                    className='zLynh'
                                                    defaultValue={this.state.password}
                                                    type={this.state.visiblePassword ? 'text' : 'password'}
                                                    onChange={(e) => this.setState({ password: e })}
                                                />
                                                <InputGroup.Button onClick={async () => {
                                                    await this.visiblePassword({ type: 'password', mode: mode, id: id })
                                                    await this.onModal({ mode: mode, id: id, read: true })
                                                }}>
                                                    {this.state.visiblePassword ? <i className="bi bi-eye-fill"></i> : <i className="bi bi-eye-slash-fill"></i>}
                                                </InputGroup.Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                    <Row className='mt-3'>
                                        <Col sm>
                                            <Form.Group>
                                                <Form.ControlLabel><b>Confirm Password</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                                <InputGroup inside >
                                                    <Input
                                                        className='hCxpm'
                                                        defaultValue={this.state.confirm_password}
                                                        type={this.state.visibleCpassword ? 'text' : 'password'}
                                                        onChange={(e) => this.setState({ confirm_password: e })}
                                                    />
                                                    <InputGroup.Button onClick={async () => {
                                                        await this.visiblePassword({ type: 'confirm_password', mode: mode, id: id })
                                                        await this.onModal({ mode: mode, id: id, read: true })
                                                    }}>
                                                        {this.state.visibleCpassword ? <i class="bi bi-eye-fill"></i> : <i class="bi bi-eye-slash-fill"></i>}
                                                    </InputGroup.Button>
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>
                                    </Row></>}

                                <Row className='mt-3'>
                                    <Col sm>
                                        <Text color="red">&#8226; รหัสผ่านประกอบด้วยตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น</Text>
                                        <Text color="red">&#8226; รหัสผ่านต้องมีความยาวระหว่าง 6 ถึง 18 ตัวอักษร</Text>
                                        <Text color="red">&#8226; รหัสผ่านต้องมีหมายเลขอย่างน้อยหนึ่งตัว</Text>
                                        <Text color="red">&#8226; รหัสผ่านต้องมีสัญลักษณ์อย่างน้อยหนึ่งตัว</Text>
                                    </Col>
                                </Row>
                            </Form>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size='sm'
                            startIcon={<i className="bi bi-floppy"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode: 'update', id: id })}>
                            บันทึก
                        </Button>
                        <Button size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}>
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            });
        }
    }

    // Function to validate a password
    validatePassword = (password) => {
        const minLength = 6;
        const maxLength = 18;
        const hasNumber = /\d/;
        const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;
        const isEnglishOnly = /^[A-Za-z0-9!@#$%^&*(),.?":{}|<>]+$/;

        if (password.length < minLength || password.length > maxLength) {
            return { valid: false, message: "รหัสผ่านต้องมีความยาวระหว่าง 6 ถึง 18 ตัวอักษร" };
        }
        if (!hasNumber.test(password)) {
            return { valid: false, message: "รหัสผ่านต้องมีหมายเลข\nอย่างน้อยหนึ่งตัว" };
        }
        if (!hasSymbol.test(password)) {
            return { valid: false, message: "รหัสผ่านต้องมีสัญลักษณ์\nอย่างน้อยหนึ่งตัว" };
        }
        if (!isEnglishOnly.test(password)) {
            return { valid: false, message: "รหัสผ่านสามารถประกอบด้วย\nตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น" };
        }
        return { valid: true };
    };

    Validate = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 500ms delay

            if (params == cond) {
                // Add 'required' class if condition is met
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (params != cond) {
                // Remove 'required' class if condition is not met
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    onConfirm = async ({ mode, id }) => {
        const validate = async () => {
            // Start with an array to collect validation promises
            const validationPromises = [
                this.Validate(this.state.name, '0uD74', ''),
                this.Validate(this.state.phone, 'q4JQq', ''),
                this.Validate(this.state.username, 'cgbZA', ''),
                ...(this.state.changePassword === true ? [
                    this.Validate(this.state.password, 'zLynh', ''),
                    this.Validate(this.state.confirm_password, 'hCxpm', ''),
                ] : []),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        if (mode === 'insert') {
            if (await validate()) {
                try {
                    this.checkpass = true;
                    const usernameResponse = await axios.get(`${process.env.REACT_APP_API}/username/${this.state.username}`, this.state.authHeader);
                    if (usernameResponse.data.count > 0) {
                        $('.cgbZA').addClass("required");
                        Swal.fire({
                            title: "ชื่อผู้ใช้นี้มีอยู่แล้ว",
                            icon: "warning",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                        this.checkpass = this.checkpass && false;
                    } else if (usernameResponse.data.count === 0) {
                        $('.cgbZA').removeClass("required");
                        this.checkpass = this.checkpass && true;
                    }

                    // Validate password with the new function
                    const passwordValidation = this.validatePassword(this.state.password);
                    if (!passwordValidation.valid) {
                        $('.zLynh').addClass("required");
                        Swal.fire({
                            title: passwordValidation.message,
                            icon: "warning",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                        this.checkpass = this.checkpass && false;
                    } else {
                        $('.zLynh').removeClass("required");
                    }

                    // Validate confirm password
                    if (this.state.password !== this.state.confirm_password) {
                        $('.hCxpm').addClass("required");
                        Swal.fire({
                            title: "รหัสผ่านไม่ตรงกัน",
                            icon: "warning",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                        this.checkpass = this.checkpass && false;
                    } else {
                        $('.hCxpm').removeClass("required");
                    }

                    if (this.checkpass === true) {
                        const Response = await axios.post(`${process.env.REACT_APP_API}/users`, {
                            name: this.state.name,
                            phone: this.state.phone,
                            username: this.state.username,
                            password: this.state.password
                        }, this.state.authHeader);

                        const users = Response.data;

                        if (users.message === 'successfully') {
                            await this.onRenderContent({ mode: 'read', query: '' })

                            await this.promisedSetState({ modal: null })

                            Swal.fire({
                                title: "คุณเพิ่มข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                        }
                    }
                } catch (error) {
                    console.log(error)
                }

            }
        } else if (mode === 'update') {
            try {
                if (this.state.changePassword === true) {

                    if (await validate()) {

                        this.checkpass = true;

                        // Validate password with the new function
                        const passwordValidation = this.validatePassword(this.state.password);
                        if (!passwordValidation.valid) {
                            $('.zLynh').addClass("required");
                            Swal.fire({
                                title: passwordValidation.message,
                                icon: "warning",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                            this.checkpass = this.checkpass && false;
                        } else {
                            $('.zLynh').removeClass("required");
                        }

                        // Validate confirm password
                        if (this.state.password !== this.state.confirm_password) {
                            $('.hCxpm').addClass("required");
                            Swal.fire({
                                title: "รหัสผ่านไม่ตรงกัน",
                                icon: "warning",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                            this.checkpass = this.checkpass && false;
                        } else {
                            $('.hCxpm').removeClass("required");
                        }

                        if (this.checkpass === true) {
                            const Response = await axios.put(`${process.env.REACT_APP_API}/users/password`, {
                                id: id,
                                name: this.state.name,
                                phone: this.state.phone,
                                password: this.state.password
                            }, this.state.authHeader);

                            const users = Response.data;

                            if (users.message === 'successfully') {
                                await this.onRenderContent({ mode: 'read', query: '' })

                                await this.promisedSetState({ modal: null })

                                Swal.fire({
                                    title: "คุณแก้ไขข้อมูลเรียบร้อยแล้ว",
                                    icon: "success",
                                    timer: 2000,
                                    timerProgressBar: true,
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                });
                            }
                        }
                    }
                } else if (this.state.changePassword === false) {
                    if (await validate()) {
                        const Response = await axios.put(`${process.env.REACT_APP_API}/users`, {
                            id: id,
                            name: this.state.name,
                            phone: this.state.phone,
                        }, this.state.authHeader);

                        const users = Response.data;

                        if (users.message === 'successfully') {
                            await this.onRenderContent({ mode: 'read', query: '' })

                            await this.promisedSetState({ modal: null })

                            Swal.fire({
                                title: "คุณแก้ไขข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        } else if (mode === 'delete') {
            Swal.fire({
                title: "คุณต้องการลบใช่หรือไม่?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                denyButtonText: `<div style="font-size: 1.425rem">ยกเลิก</div>`,
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {

                    const Response = await axios.delete(`${process.env.REACT_APP_API}/users/${id}`, this.state.authHeader);

                    const ethnics = Response.data;

                    if (ethnics.message === 'successfully') {

                        await this.onRenderContent({ mode: 'read', query: '' })

                        Swal.fire({
                            title: "คุณลบข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }
                } else if (result.isDenied) {

                    await this.onRenderContent({ mode: 'read', query: '' })
                }
            });
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
